<template>
  <div class="row m-0">
    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" v-if="!loading">
      <h2 class="title font-weight-bold text-uppercase titlePagamento">
        {{ dados.nome ? dados.nome : '' }} {{ dados.preco ? ' - "'+dados.preco+' ('+dados.preco_text+')'+'"' : '' }}
      </h2>
      <span class="descricaoPagamento">{{ dados.descricao ? dados.descricao : '' }}</span>
      <hr class="linha-amarela" />
    </div>

    <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 formatCardCenter">
      <b-row>
        <b-col cols="12" class="text-center mb-4">
          <img
                width="60px"
                src="@/assets/img/cartoes/logo-visa-256.png"
                alt="Visa"
              />
              <img
                class="ml-3"
                width="60px"
                src="@/assets/img/cartoes/logo-mastercard-256.png"
                alt="Visa"
              />
              <img
                class="ml-3"
                width="60px"
                src="@/assets/img/cartoes/logo-cartao-elo-256.png"
                alt="Visa"
              />
              <img
                class="ml-3"
                width="60px"
                src="@/assets/img/cartoes/logo-hipercard-256.png"
                alt="Visa"
              />
              <img
                class="ml-3"
                width="60px"
                src="@/assets/img/cartoes/logo-diners-club-international-256.png"
                alt="Visa"
              />
              <img
                class="ml-3"
                width="60px"
                src="@/assets/img/cartoes/logo-american-express-256.png"
                alt="Visa"
              />
        </b-col>

        <b-col cols="12">
          <div class="card-wrapper mb-5"></div>
        </b-col>
      </b-row>
    </div>

    <div id="cc-form" class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 mb-3">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-2">
          <label>Número cartão</label>
          <input
            class="form-control"
            id="cc-number"
            type="text"
            name="number"
            v-model="number"
            placeholder="xxxx - xxxx - xxxx - xxxx"
          />
        </div>

        <div class="col-12 col-sm-12 col-md-6 col-lg-12 col-xl-6 mb-2">
          <label>Primeiro nome</label>
          <input
            class="form-control"
            id="ccName"
            type="text"
            name="ccName"
            v-model="ccName"
            placeholder="Ex: João"
          />
          <span class="color-aviso">* Conforme impresso no cartão</span>
        </div>

        <div class="col-12 col-sm-12 col-md-6 col-lg-12 col-xl-6 mb-2">
          <label>Sobrenome</label>
          <input
            class="form-control"
            id="last-name"
            type="text"
            name="last-name"
            v-model="lastname"
            placeholder="Ex: Silva Ramos"
          />
        </div>

        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 mb-2">
          <label>Mês de expiração do cartão</label>
          <input
            class="form-control"
            id="cc-expiration"
            type="text"
            name="expiry"
            v-model="month"
            placeholder="xx"
              maxlength="2"
          />
        </div>

        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 mb-2">
          <label>Ano de expiração do cartão</label>
          <input
            class="form-control"
            id="cc-expiration"
            type="text"
            name="expiry"
            v-model="year"
            placeholder="xxxx"
            maxlength="4"
          />
        </div>

        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-4 mb-2">
          <label for="email">CVV/CVC</label>
          <input
            class="form-control"
            id="cc-cvv"
            type="text"
            name="cvc"
            v-model="cvv"
            placeholder="xxx"
            maxlength="4"
            @focus="validCVC('back')"
            @blur="validCVC('front')"
          />
        </div>
      </div>

      <div class="row">
        <div class="col-6">
          <label>Cupom desconto</label>
          <span class="ml-4" style="color:red" v-if="cupomInvalido == true">Cupom inválido</span>
          <span class="ml-4" style="color:green" v-if="cupomValido == true">Cupom valido</span>
          <input type="text" class="form-control" v-model="cupomDesconto" placeholder="Digite o cupom de desconto">
        </div>
        <div class="col-6 alinharBtn">
          <button class="btn btn-success btn-block" @click="validarCupom()">Validar cupom</button>
        </div>
      </div>

      <button @click="submitCC()" class="mt-3 btn btn-success btn-block">Realizar pagamento</button>

    </div>
  </div>
</template>

<script type="text/javascript" src="https://js.iugu.com/v2"></script>
<script>
import * as Card from 'card';
import { mapState } from 'vuex';
import makeToast from '../../mixins/makeToast';

export default {
  name: 'CartaoCreditoAppAss',
  data() {
    return {
      cupomValido: false,
      cupomInvalido: false,
      cupomDesconto: '',
      dados: [],
      number: '',
      ccName: '',
      lastname: '',
      month: '',
      year: '',
      cvv: '',
      valid: false,
      classCard: '',
      loading: false
    };
  },
  mixins: [makeToast],
  computed: {
    ...mapState(['dadosUsuario']),
  },
  watch: {
    'ccName': function () {
      const name = document.querySelectorAll('.jp-card-name')
      const nameFull = this.ccName +' '+ this.lastname
      name[0].innerText = nameFull
    },
    'lastname': function () {
      const name = document.querySelectorAll('.jp-card-name')
      const nameFull = this.ccName +' '+ this.lastname
      name[0].innerText = nameFull
    },
    'month': function () {
      const cardExpiry = document.querySelectorAll('.jp-card-expiry')
      const cardFull = this.month +'/'+ this.year
      cardExpiry[0].innerText = cardFull
    },
    'year': function () {
      const cardExpiry = document.querySelectorAll('.jp-card-expiry')
      const cardFull = this.month +'/'+ this.year
      cardExpiry[0].innerText = cardFull
    },
    'cvv': function () {
      const cvv = document.querySelectorAll('.jp-card-cvc')
      console.log(cvv)
      cvv[1].innerText = this.cvv
    }
  },
  mounted() {
    this.buscarAssinatura();
    let Script = document.createElement('script');
    Script.setAttribute('src', 'https://js.iugu.com/v2');
    document.head.appendChild(Script);

    // eslint-disable-next-line no-new
    new Card({
      form: 'div#cc-form',
      container: '.card-wrapper',
      formSelectors: {
        numberInput: 'input#cc-number',
        nameInput: 'input#ccName',
        expiryInput: 'input#cc-month, input#cc-year',
        cvcInput: 'input#cc-cvv',
      },
      width: 370,
      formatting: true,
      messages: {
        validDate: 'valido\ndata',
        monthYear: 'mm/yyyy',
      },
      placeholders: {
        number: '•••• •••• •••• ••••',
        name: 'Nome completo',
        expiry: '••/••',
        cvc: '•••',
      },
    });
  },
  methods: {
    buscarAssinatura() {
      this.$store.dispatch('startLoader');
      this.loading = true;
      this.$store.dispatch('shopkeeper/buscarValorAss', this.dadosUsuario.id)
        .then((response) => {
          if(response.data.error == false) {
            this.dados = response.data.data;
          } else {
            this.makeToast('Oops!', 'Não foi possível buscar dados do plano!', 'danger');
            this.$router.push({ name: 'lojista-assinatura-app-site'});
          }
        })
        .finally(() => {
          this.loading = false;
          this.$store.dispatch('endLoader');
        })
    },
    validarCupom() {
      this.$store.dispatch('startLoader');
      this.loading = true;

      var data = {
        cupom: this.cupomDesconto,
        usuario_id: this.dadosUsuario.id
      }

      this.$store.dispatch('shopkeeper/validarCupomDesconto', data)
        .then((response) => {
          if(response.data.error == false) {
            this.makeToast('Sucesso', response.data.message, 'success');
            this.cupomValido = true;
            this.cupomInvalido = false;
            this.dados = response.data.data;
          } else {
            this.cupomValido = false;
            this.cupomInvalido = true;
            this.makeToast('Oops!', response.data.message, 'danger');
          }
        })
        .finally(() => {
          this.loading = false;
          this.$store.dispatch('endLoader');
        })
    },
    submitCC() {
      this.validPayment();
      if(this.valid == false) {
        return;
      }

      this.$store.dispatch('startLoader');
      Iugu.setAccountID('D9BC3DAFD6314DE2B01323646B94F29B');
      Iugu.setup();
      Iugu.setTestMode(false);
      const cc = Iugu.CreditCard(
        this.number,
        this.month,
        this.year,
        this.ccName,
        this.lastname,
        this.cvv
      );
      Iugu.createPaymentToken(cc, (response) => {
        if (response.errors) {
          this.$store.dispatch('endLoader');
          this.makeToast('Oops!', 'Não foi possível salvar o cartão', 'danger');
        } else {
          const data = {
            usuario_id: this.dadosUsuario.id,
            lojista_id: this.dadosUsuario.informacoes.id,
            token: response.id,
            cupom: this.cupomDesconto
          };

          this.$store.dispatch('shopkeeper/efetuarPagamentoApp', data)
          .then((resp) => {
            if(resp.data.message == 'success') {
              this.makeToast('Sucesso', 'Assinatura contratada com sucesso', 'success');
              this.$root.$emit('valid-status-app');
              this.$router.push({ name: 'lojista-home'});
            } else {
              this.makeToast('Oops!', 'Não foi possível realizar o pagamento', 'danger');
            }
          })
          .catch(() => {
            this.makeToast('Oops!', 'Não foi possível realizar o pagamento', 'danger');
          })
          .finally(() => {
            this.$store.dispatch('endLoader');
          })
        }
      });
    },
    validCVC(type) {
      const front = document.querySelectorAll('.jp-card')
      if (type == 'back') {
        this.classCard = front[0].className;
        front[0].className = 'jp-card jp-card-flipped';
      }
      if (type == 'front') {
        front[0].className = this.classCard;
      }
    },

    validPayment() {
      this.valid = true;
      if(this.number == '') {
        this.makeToast('Oops!', 'Preencha o número do seu cartão!', 'danger');
        this.valid = false;
      }
      if(this.ccName == '') {
        this.makeToast('Oops!', 'Informe seu nome!', 'danger');
        this.valid = false;
      }
      if(this.lastname == '') {
        this.makeToast('Oops!', 'Informe seu sobrenome!', 'danger');
        this.valid = false;
      }
      if(this.month == '') {
        this.makeToast('Oops!', 'Informe o mês da validade do seu cartão!', 'danger');
        this.valid = false;
      }
      if(this.year == '') {
        this.makeToast('Oops!', 'Informe o ano da validade do seu cartão!', 'danger');
        this.valid = false;
      }
      if(this.cvv == '') {
        this.makeToast('Oops!', 'Informe o cvv do seu cartão!', 'danger');
        this.valid = false;
      }
    },
  },
};
</script>

<style scoped>
.color-success {
  color: rgb(237, 118, 70);
}
.formatCardCenter {
  display: flex;
  align-items: center;
  justify-content: center;
}
.color-aviso {
  color: #666666;
}
.alinharBtn {
  justify-content: flex-end;
  align-items: flex-end;
  display: flex;
}
@media (min-width: 768px) and (max-width: 1024px) {
  .titlePagamento {
    font-size: 28px;
  } 
  .descricaoPagamento {
    font-size: 18px;
  }  
}
@media (min-width: 481px) and (max-width: 767px) {
  .titlePagamento {
    font-size: 22px;
  } 
  .descricaoPagamento {
    font-size: 14px;
  } 
}
@media (min-width: 320px) and (max-width: 480px) {
  .titlePagamento {
    font-size: 18px;
  } 
  .descricaoPagamento {
    font-size: 12px;
  } 
}
</style>